import '../lib/js-cookie-2.2.0';

function market() {
  const onMarketLnkClick = e => {
    let country = e.currentTarget.dataset.country;

    let expires = 60;
    Cookies.set('Market', country, { expires: expires, path: '/' });
  };

  const init = () => {
    const marketLinks = [...document.querySelectorAll('.js-market-lnk')];
    marketLinks.forEach(lnk => {
      lnk.addEventListener('click', onMarketLnkClick);
    });

    const modal = document.querySelector('.js-modal');
    if (modal) {
      document.body.classList.add('overflow-hidden');
    }
  };

  init();
}
export default market;
